import geneTestResultsFilterByResult from './geneTestResultsFilterByResult';


// WEBPACK FOOTER //
// ./src/scripts/filters/index.js